import { render, staticRenderFns } from "./vLoadingInterface.vue?vue&type=template&id=48577efe&scoped=true"
import script from "./vLoadingInterface.vue?vue&type=script&lang=js"
export * from "./vLoadingInterface.vue?vue&type=script&lang=js"
import style0 from "./vLoadingInterface.vue?vue&type=style&index=0&id=48577efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48577efe",
  null
  
)

export default component.exports